import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { EmpresaQueVendeComCartoesService } from '../../core/services/empresa-que-vende-com-cartoes.service'
import { OperadoraDeMaquinaService } from '../../core/services/operadora-de-maquina.service'
import { EmpresaQueVendeComCartoes } from '../../pkw-data/collect/empresa-que-vende-com-cartoes.model'
import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { LocalDateConverter } from '../../pkw-data/core/converters/local-date.converter'
import { OpcoesRelatorio } from './opcoes-relatorio.interface'

@Injectable()
export class OpcoesRelatorioResolver implements Resolve<OpcoesRelatorio> {
    constructor(
        private empresaQVCCService: EmpresaQueVendeComCartoesService,
        private operadoraService: OperadoraDeMaquinaService
    ) {}

    resolve(route: ActivatedRouteSnapshot) {
        const empresa$ = route.queryParams.empresa
            ? this.empresaQVCCService.obterPorIdExterno(route.queryParams.empresa)
            : (Observable.of(undefined) as Observable<EmpresaQueVendeComCartoes>)
        const operadora$ = route.queryParams.operadora
            ? this.operadoraService.obterPorCodename(route.queryParams.operadora)
            : (Observable.of(undefined) as Observable<OperadoraDeMaquina>)

        return Observable.forkJoin(empresa$, operadora$).map(([empresa, operadora]) => {
            return {
                empresa,
                operadora,
                inicio: LocalDateConverter.toModel(route.queryParams.inicio),
                fim: LocalDateConverter.toModel(route.queryParams.fim),
                tipoDeMovimento: route.queryParams.movimento,
                tipoDeRelatorio: route.queryParams.tipo,
                tipoDeBinario: route.queryParams.binario
            } as OpcoesRelatorio
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/relatorio/opcoes-relatorio.resolver.ts